import React from "react";
import BigCalendar from "react-big-calendar";
import moment from "moment";
import "moment/locale/es";
import { Container, Row, Card, CardBody } from "shards-react";
import api from "../../common/api";
import axios from "axios";
import PageTitle from "../../common/PageTitle";
import { LinearProgress } from "@material-ui/core";

function EventAgenda({ event }) {
  var id = event.id;
  return (
    <p>
      <a
        class="text-decoration-none"
        style={{ color: event.font_color }}
        href={`/booking/${id}`}
        target="_blank"
      >
        {event.title}
      </a>
    </p>
  );
}

class BookingCalendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      events: null,
      loaded: false,
      work_order_types: [],
      events_filtered: [{ driver: { id: 0 } }],
      events: [{ driver: { id: 0 } }]
    };
  }

  async componentWillMount() {
    let events = await this.getBookingsShifts();
    this.setState({
      ...this.state,
      events,
      loaded: true
    });
  }

  eventStyleGetter = (event, start, end, isSelected) => {
    var style = {
      backgroundColor: event.card_color ? event.card_color : "#007bff",
      borderRadius: "0px",
      opacity: 0.8,
      color: event.font_color ? event.font_color : "#fff",
      border: "0px",
      display: "block"
    };
    return {
      style: style
    };
  };

  getBookingsShifts = () => {
    const token = localStorage.getItem("userToken");
    var events = [];
    var i = 0;
    return axios
      .get(api.bookings().shifts(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var data = res.data ? res.data.data : [];
        data.map((val, idx) => {
          var event = {};
          event.hansa_plate = val.hansa_plate;
          event.hansa_code = val.hansa_code;
          val.expected_pickup_date.replace(" ", "T");
          event.start = new Date(Date.parse(val.expected_pickup_date));
          event.end = new Date(Date.parse(val.expected_pickup_date));
          event.end.setMinutes(event.end.getMinutes() + 60);
          event.title = "#" + val.id + " - " + val.plate.plate;
          event.id = val.id;
          i++;
          events.push(event);
        });
        return events;
      })
      .catch(err => {
        console.log(err);
      });
  };

  render() {
    const { events } = this.state;
    moment.locale("es");
    const localizer = BigCalendar.momentLocalizer(moment);
    const views = ["month", "work_week", "day", "agenda"];
    const messages = {
      date: "Fecha",
      time: "Hora",
      event: "Evento",
      allDay: "Todo el día",
      week: "Semana",
      work_week: "Semana",
      day: "Dia",
      month: "Mes",
      previous: "Atrás",
      next: "Adelante",
      yesterday: "Ayer",
      tomorrow: "Mañana",
      today: "Hoy",
      agenda: "Agenda",
      noEventsInRange: "No hay eventos.",
      showMore: function showMore(total) {
        return "+" + total + " más";
      }
    };
    return (
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header py-4">
          <PageTitle
            title="Entrega de vehículos"
            className="text-sm-left mb-3"
          />
        </Row>
        {this.state.loaded ? (
          <Card className="p-0">
            <CardBody className="py-4">
              <BigCalendar
                events={events}
                messages={messages}
                views={views}
                defaultView={"month"}
                step={30}
                popup={true}
                popupOffset={{ x: 30, y: 20 }}
                length={30}
                startAccessor="start"
                endAccessor="end"
                showMultiDayTimes
                defaultDate={new Date()}
                onSelectEvent={e => {
                  window.open(`/booking/${e.id}`, "_blank");
                }}
                eventPropGetter={this.eventStyleGetter}
                localizer={localizer}
                components={{
                  agenda: {
                    event: EventAgenda
                  }
                }}
              />
            </CardBody>
          </Card>
        ) : (
          <LinearProgress />
        )}
      </Container>
    );
  }
}

export default BookingCalendar;
